// Per-organization feature entitlements.
//
// The API returns an `org.features` array of enabled feature keys on the
// logged-in user (see UserAccessSerializer.get_org in expostudio-api). Gate a
// feature in the UI with `hasFeature(props.user, 'webview')`. A missing/empty
// list reads as "off", which is the safe default for features that haven't been
// granted to an org yet.

export const hasFeature = (user, key) =>
  Array.isArray(user?.org?.features) && user.org.features.includes(key);
